import classNames from 'classnames';
import { useRef } from 'react';
import { ReactComponent as MenuRight } from 'src/Themes/assets/menu-right.svg';
import { ReactComponent as QueueWaitingIcon } from './Assets/ReTurnQueue/QueueWaiting.svg';
import { ReactComponent as TimerReTurnIcon } from './Assets/ReTurnQueue/Timer.svg';
import { PointType } from '.';
import { Hint } from '@redoc/ui-kit';
import { formatReturnMenuHint, EQMenuStatusBadgeType } from './returnMenuStatusBadge';
import './EQMenuButton.scss';

export type { EQMenuStatusBadgeType } from './returnMenuStatusBadge';

interface IButtonProps {
	isWait?: boolean;
	iconClass: string;
	title: string;
	disabled?: boolean;
	color?: string;
	isActive?: boolean;
	isExpanded?: boolean;
	statusBadge?: EQMenuStatusBadgeType;
	onClick: ( position: PointType ) => void;
};

/** Кнопка меню электронной очереди */
export const EQMenuButton: React.FC<IButtonProps> = ({
	isActive = false,
	isWait = false,
	iconClass,
	title,
	disabled,
	onClick,
	color,
	isExpanded = false,
	statusBadge
}) => {

	const btnRef = useRef<HTMLLIElement>(null);
	const showStatusBadge = !!statusBadge && isExpanded;
	const hintText = statusBadge ? formatReturnMenuHint( statusBadge ) : title;

	/** CSS классы для элемента меню */
	const itemClasses = classNames("menu_item menu_button enter-eq", {
		"menu_item-disabled": disabled,
		"active": isActive
	});

	/** CSS классы для текста кнопки */
	const titleClasses = classNames("menu_item-text", {
		"open": isExpanded
	});

	/** Обработчик клика по кнопке меню */
	const onClickHandler = (e: React.MouseEvent<HTMLLIElement>) => {
		e.stopPropagation();
		if ( !!onClick && !!btnRef?.current ) {
			onClick( { left: btnRef.current.offsetLeft, top: ( btnRef.current.offsetTop - 55) });
		}
	};

	const renderBadgeSuffix = () => {
		if ( !statusBadge ) {
			return null;
		}
		if ( statusBadge.queueCount != null ) {
			return (
				<span className="eq_menu_status_badge__suffix">
					<span className="eq_menu_status_badge__queue">
						<QueueWaitingIcon />
						<span>{statusBadge.queueCount}</span>
					</span>
				</span>
			);
		}
		if ( statusBadge.ticketNumber ) {
			return (
				<span className="eq_menu_status_badge__suffix">
					<span className="eq_menu_status_badge__ticket">{statusBadge.ticketNumber}</span>
					{!!statusBadge.time && (
						<span className="eq_menu_status_badge__timer">
							<TimerReTurnIcon />
							<span>{statusBadge.time}</span>
						</span>
					)}
				</span>
			);
		}
		if ( statusBadge.time ) {
			return (
				<span className="eq_menu_status_badge__suffix">
					<span className="eq_menu_status_badge__timer">
						<TimerReTurnIcon />
						<span>{statusBadge.time}</span>
					</span>
				</span>
			);
		}
		return null;
	};

	const menuButton = (
		<button className="menu_item-wrapper" type="button">
			<div className="menu_item-wrapper-inner">
				<MenuRight className="menu_item__arrow" />
				<span className={'menu-icon ' + iconClass} style={{ color: "white" }} />
			</div>
			{showStatusBadge ? (
				<span className={titleClasses}>
					<span className="eq_menu_status_badge">
						<span className="eq_menu_status_badge__label">{statusBadge?.label}</span>
						{renderBadgeSuffix()}
					</span>
				</span>
			) : (
				<span className={titleClasses}>{title}</span>
			)}
			{ isWait && <span className='rdc_small_spiner' style={{ marginLeft: '1rem', color: 'white', backgroundColor: "white" }}/> }
		</button>
	);

	return (
		<li
			ref={btnRef}
			className={itemClasses}
			style={{ backgroundColor: color || undefined }}
			onClick={ (e) => onClickHandler(e)}
		>
			{isExpanded ? menuButton : (
				<Hint placement="right" messageText={hintText}>
					{menuButton}
				</Hint>
			)}
		</li>
	);
};
